import {createSelector} from "@reduxjs/toolkit";
import MeasureListState from "../types/MeasureListState";
import {State} from "../../../store";
import useSelector from "../../common/hooks/useSelector";

export default function useMeasureListSelector<TSelected>(selector: (state: MeasureListState) => TSelected, equalityFn?: (left: TSelected, right: TSelected) => boolean): TSelected {
    const reselect = createSelector((state: State) => state.measureList, selector);
    return useSelector(reselect, equalityFn);
}